import { commonOptions } from '@/config'
import { addEditDialog } from './_dialogs'
import { getTableStatusEditor } from '@/utils'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/device/device-model/pageList'
      },
      add: {
        api: '/sys/admin/device/device-model/save',
        dialog: addEditDialog(false)
      },
      edit: {
        api: '/sys/admin/device/device-model/edit',
        dialog: addEditDialog(true)
      },
      export: {}
    },
    search: {
      items: [
        { type: 'input', prop: 'modelName', label: '型号名称' },
        { type: 'input', prop: 'modelCode', label: '型号编码' },
        { type: 'input', prop: 'manufacturerName', label: '供货厂商' },
        { type: 'select', prop: 'deviceTypeCode', label: '设备类型', options: 'tdlDeviceType' }
      ]
    },
    toolbar: {
      items: [{ action: 'add', label: '新增' }]
    },
    table: {
      editable: true,
      innerAttrs: { rowKey: 'modelCode' },
      operation: {
        width: 100,
        items: [{ action: 'edit' }]
      },
      columns: [
        { label: '厂商', prop: 'manufacturerName', width: 120 },
        { label: '型号名称', prop: 'modelName', width: 120 },
        { label: '型号编码', prop: 'modelCode', width: 120 },
        { label: '实体类型', prop: 'deviceTypeName', width: 100 },
        { label: '格口模版', prop: 'cellTemplateName', minWidth: 180 },
        { label: '舱体尺寸', prop: 'cabinSize', width: 120 },
        { label: '应用设备数', prop: 'refDeviceCount', width: 100 },
        {
          label: '状态',
          prop: 'status',
          width: 120,
          formatter: { name: 'enumStr', options: commonOptions.enableStatus },
          editor: getTableStatusEditor({
            api: '/sys/admin/device/device-model/changeStatus',
            apiParams: (model: any) => ({ modelCode: model.modelCode })
          })
        }
      ]
    }
  }
}
